import kotlinx.serialization.Serializable

@Serializable
enum class UserDialogMode {
    CREATE,
    EDIT,
    UNKNOWN
}
